/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '@angular/common';
import * as i3 from '../../../../../src/app/components/ingresocausa/repre-causa-popup.component';
import * as i4 from '../../common/dialog/mensaje.component.ngfactory';
import * as i5 from '../../../../../src/app/common/dialog/mensaje.component';
import * as i6 from '../../../../../src/app/services/usuario.service';
import * as i7 from '../../../../../src/app/services/expediente.service';
import * as i8 from '../../../../../src/app/services/common.service';
var styles_RepreCausaPopupComponent = [];
export var RenderType_RepreCausaPopupComponent = i0.ɵcrt({ encapsulation: 2,
    styles: styles_RepreCausaPopupComponent, data: {} });
function View_RepreCausaPopupComponent_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class',
                'col-xs-10 col-sm-8']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'h4', [['class', 'modal-title']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Representante'])), (_l()(), i0.ɵted(null, ['\n                ']))], null, null);
}
function View_RepreCausaPopupComponent_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.id;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.id;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.descr;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_RepreCausaPopupComponent_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 3, 'option', [], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0, 'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(), i0.ɵted(null, ['', '']))], function (_ck, _v) {
        var currVal_0 = _v.context.$implicit.codigo;
        _ck(_v, 1, 0, currVal_0);
        var currVal_1 = _v.context.$implicit.codigo;
        _ck(_v, 2, 0, currVal_1);
    }, function (_ck, _v) {
        var currVal_2 = _v.context.$implicit.codigo;
        _ck(_v, 3, 0, currVal_2);
    });
}
function View_RepreCausaPopupComponent_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 128, 'div', [], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n                     '])), (_l()(), i0.ɵeld(0, null, null, 29, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 26, 'div', [['class', 'col-sm-12']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 23, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 20, 'div', [['class', 'select']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Caracter '])), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 14, 'select', [['class', 'form-control bginputs']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'change'], [null, 'focus'], [null, 'ngModelChange'], [null,
                'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 14).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 14).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('change' === en)) {
                var pd_2 = (_co.onChangeSelectTvi($event.target.value) !== false);
                ad = (pd_2 && ad);
            }
            if (('focus' === en)) {
                var pd_3 = (_co.hideErrorMsg() !== false);
                ad = (pd_3 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_4 = ((_co.repre.tvi_id = $event) !== false);
                ad = (pd_4 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.SelectControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.SelectControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 3, 'option', [['value', '0']], null, null, null, null, null)), i0.ɵdid(147456, null, 0, i1.NgSelectOption, [i0.ElementRef, i0.Renderer2, [2, i1.SelectControlValueAccessor]], { value: [0,
                'value'] }, null), i0.ɵdid(147456, null, 0, i1.ɵq, [i0.ElementRef,
            i0.Renderer2, [8, null]], { value: [0, 'value'] }, null), (_l()(),
            i0.ɵted(null, ['Seleccionar...'])), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_RepreCausaPopupComponent_3)), i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef, i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 53, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 24, 'div', [['class', 'col-sm-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 21, 'div', [['class', 'form-group']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵeld(0, null, null, 18, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 15, 'div', [['class', 'select']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Tipo de Documento '])),
        (_l()(), i0.ɵted(null, ['\n                                        '])),
        (_l()(), i0.ɵeld(0, null, null, 9, 'select', [['class', 'form-control bginputs']], [[2, 'ng-untouched', null], [2, 'ng-touched', null], [2, 'ng-pristine',
                null], [2, 'ng-dirty', null], [2, 'ng-valid', null],
            [2, 'ng-invalid', null], [2, 'ng-pending', null]], [[null,
                'ngModelChange'], [null, 'focus'], [null, 'change'], [null,
                'blur']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('change' === en)) {
                var pd_0 = (i0.ɵnov(_v, 47).onChange($event.target.value) !== false);
                ad = (pd_0 && ad);
            }
            if (('blur' === en)) {
                var pd_1 = (i0.ɵnov(_v, 47).onTouched() !== false);
                ad = (pd_1 && ad);
            }
            if (('ngModelChange' === en)) {
                var pd_2 = ((_co.repre.tdo_cod = $event) !== false);
                ad = (pd_2 && ad);
            }
            if (('focus' === en)) {
                var pd_3 = (_co.hideErrorMsg() !== false);
                ad = (pd_3 && ad);
            }
            return ad;
        }, null, null)), i0.ɵdid(16384, null, 0, i1.SelectControlValueAccessor, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.SelectControlValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { model: [0, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(), i0.ɵted(null, ['\n                                            '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_RepreCausaPopupComponent_4)),
        i0.ɵdid(802816, null, 0, i2.NgForOf, [i0.ViewContainerRef, i0.TemplateRef,
            i0.IterableDiffers], { ngForOf: [0, 'ngForOf'] }, null), (_l()(), i0.ɵted(null, ['\n                                        '])), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 18, 'div', [['class', 'col-sm-6']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 15, 'div', [['class', 'form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 12, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['N° de Documento'])),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 6, 'input', [['class', 'form-control input-sm bginputs'],
                ['name', 'documento'], ['type', 'number']], [[2, 'ng-untouched', null],
                [2, 'ng-touched', null], [2, 'ng-pristine', null], [2, 'ng-dirty',
                    null], [2, 'ng-valid', null], [2, 'ng-invalid', null],
                [2, 'ng-pending', null]], [[null, 'keypress'], [null,
                    'focus'], [null, 'ngModelChange'], [null, 'input'], [null,
                    'blur'], [null, 'compositionstart'], [null, 'compositionend'],
                [null, 'change']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('input' === en)) {
                    var pd_0 = (i0.ɵnov(_v, 71)._handleInput($event.target.value) !== false);
                    ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                    var pd_1 = (i0.ɵnov(_v, 71).onTouched() !== false);
                    ad = (pd_1 && ad);
                }
                if (('compositionstart' === en)) {
                    var pd_2 = (i0.ɵnov(_v, 71)._compositionStart() !== false);
                    ad = (pd_2 && ad);
                }
                if (('compositionend' === en)) {
                    var pd_3 = (i0.ɵnov(_v, 71)._compositionEnd($event.target.value) !== false);
                    ad = (pd_3 && ad);
                }
                if (('change' === en)) {
                    var pd_4 = (i0.ɵnov(_v, 72).onChange($event.target.value) !== false);
                    ad = (pd_4 && ad);
                }
                if (('input' === en)) {
                    var pd_5 = (i0.ɵnov(_v, 72).onChange($event.target.value) !== false);
                    ad = (pd_5 && ad);
                }
                if (('blur' === en)) {
                    var pd_6 = (i0.ɵnov(_v, 72).onTouched() !== false);
                    ad = (pd_6 && ad);
                }
                if (('keypress' === en)) {
                    var pd_7 = (_co._keyPress($event) !== false);
                    ad = (pd_7 && ad);
                }
                if (('focus' === en)) {
                    var pd_8 = (_co.hideErrorMsg() !== false);
                    ad = (pd_8 && ad);
                }
                if (('ngModelChange' === en)) {
                    var pd_9 = ((_co.repre.numero = $event) !== false);
                    ad = (pd_9 && ad);
                }
                return ad;
            }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵdid(16384, null, 0, i1.ɵbc, [i0.Renderer2, i0.ElementRef], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0, p1_0) {
            return [p0_0, p1_0];
        }, [i1.DefaultValueAccessor, i1.ɵbc]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null], [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'], model: [1, 'model'] }, { update: 'ngModelChange' }), i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null), (_l()(),
            i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵted(null, ['\n                         '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-sm-2']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-primary btn-verMas btn-buscar']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onClickBuscarPro() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['Buscar'])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                   '])),
        (_l()(), i0.ɵeld(0, null, null, 39, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class', 'col-sm-6']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class', 'form-group']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵeld(0, null, null, 11, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Nombre'])),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 5, 'input', [['class', 'form-control input-sm bginputs t-upper'],
                ['disabled', ''], ['name', 'nombre'], ['type', 'text']], [[2, 'ng-untouched',
                    null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
                [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                    null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
                [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
                [null, 'compositionend']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('input' === en)) {
                    var pd_0 = (i0.ɵnov(_v, 100)._handleInput($event.target.value) !== false);
                    ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                    var pd_1 = (i0.ɵnov(_v, 100).onTouched() !== false);
                    ad = (pd_1 && ad);
                }
                if (('compositionstart' === en)) {
                    var pd_2 = (i0.ɵnov(_v, 100)._compositionStart() !== false);
                    ad = (pd_2 && ad);
                }
                if (('compositionend' === en)) {
                    var pd_3 = (i0.ɵnov(_v, 100)._compositionEnd($event.target.value) !== false);
                    ad = (pd_3 && ad);
                }
                if (('ngModelChange' === en)) {
                    var pd_4 = ((_co.repre.nombre = $event) !== false);
                    ad = (pd_4 && ad);
                }
                return ad;
            }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 17, 'div', [['class', 'col-sm-6']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵeld(0, null, null, 14, 'div', [['class', 'form-group']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(), i0.ɵeld(0, null, null, 11, 'div', [['class', 'fg-line']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'label', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['Apellido'])),
        (_l()(), i0.ɵted(null, ['\n                                    '])), (_l()(),
            i0.ɵeld(0, null, null, 5, 'input', [['class', 'form-control input-sm bginputs t-upper'],
                ['disabled', ''], ['name', 'apellido'], ['type', 'text']], [[2, 'ng-untouched',
                    null], [2, 'ng-touched', null], [2, 'ng-pristine', null],
                [2, 'ng-dirty', null], [2, 'ng-valid', null], [2, 'ng-invalid',
                    null], [2, 'ng-pending', null]], [[null, 'ngModelChange'],
                [null, 'input'], [null, 'blur'], [null, 'compositionstart'],
                [null, 'compositionend']], function (_v, en, $event) {
                var ad = true;
                var _co = _v.component;
                if (('input' === en)) {
                    var pd_0 = (i0.ɵnov(_v, 119)._handleInput($event.target.value) !== false);
                    ad = (pd_0 && ad);
                }
                if (('blur' === en)) {
                    var pd_1 = (i0.ɵnov(_v, 119).onTouched() !== false);
                    ad = (pd_1 && ad);
                }
                if (('compositionstart' === en)) {
                    var pd_2 = (i0.ɵnov(_v, 119)._compositionStart() !== false);
                    ad = (pd_2 && ad);
                }
                if (('compositionend' === en)) {
                    var pd_3 = (i0.ɵnov(_v, 119)._compositionEnd($event.target.value) !== false);
                    ad = (pd_3 && ad);
                }
                if (('ngModelChange' === en)) {
                    var pd_4 = ((_co.repre.apellido = $event) !== false);
                    ad = (pd_4 && ad);
                }
                return ad;
            }, null, null)), i0.ɵdid(16384, null, 0, i1.DefaultValueAccessor, [i0.Renderer2, i0.ElementRef, [2, i1.COMPOSITION_BUFFER_MODE]], null, null), i0.ɵprd(1024, null, i1.NG_VALUE_ACCESSOR, function (p0_0) {
            return [p0_0];
        }, [i1.DefaultValueAccessor]), i0.ɵdid(671744, null, 0, i1.NgModel, [[8, null],
            [8, null], [8, null], [2, i1.NG_VALUE_ACCESSOR]], { name: [0, 'name'],
            isDisabled: [1, 'isDisabled'], model: [2, 'model'] }, { update: 'ngModelChange' }),
        i0.ɵprd(2048, null, i1.NgControl, null, [i1.NgModel]), i0.ɵdid(16384, null, 0, i1.NgControlStatus, [i1.NgControl], null, null),
        (_l()(), i0.ɵted(null, ['\n                                '])), (_l()(),
            i0.ɵted(null, ['\n                            '])), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                    '])),
        (_l()(), i0.ɵted(null, ['\n\n\n                ']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_7 = _co.repre.tvi_id;
        _ck(_v, 16, 0, currVal_7);
        var currVal_8 = '0';
        _ck(_v, 21, 0, currVal_8);
        var currVal_9 = '0';
        _ck(_v, 22, 0, currVal_9);
        var currVal_10 = _co.tviListRepre;
        _ck(_v, 26, 0, currVal_10);
        var currVal_18 = _co.repre.tdo_cod;
        _ck(_v, 49, 0, currVal_18);
        var currVal_19 = _co.tdocList;
        _ck(_v, 54, 0, currVal_19);
        var currVal_27 = 'documento';
        var currVal_28 = _co.repre.numero;
        _ck(_v, 74, 0, currVal_27, currVal_28);
        var currVal_36 = 'nombre';
        var currVal_37 = '';
        var currVal_38 = _co.repre.nombre;
        _ck(_v, 102, 0, currVal_36, currVal_37, currVal_38);
        var currVal_46 = 'apellido';
        var currVal_47 = '';
        var currVal_48 = _co.repre.apellido;
        _ck(_v, 121, 0, currVal_46, currVal_47, currVal_48);
    }, function (_ck, _v) {
        var currVal_0 = i0.ɵnov(_v, 18).ngClassUntouched;
        var currVal_1 = i0.ɵnov(_v, 18).ngClassTouched;
        var currVal_2 = i0.ɵnov(_v, 18).ngClassPristine;
        var currVal_3 = i0.ɵnov(_v, 18).ngClassDirty;
        var currVal_4 = i0.ɵnov(_v, 18).ngClassValid;
        var currVal_5 = i0.ɵnov(_v, 18).ngClassInvalid;
        var currVal_6 = i0.ɵnov(_v, 18).ngClassPending;
        _ck(_v, 13, 0, currVal_0, currVal_1, currVal_2, currVal_3, currVal_4, currVal_5, currVal_6);
        var currVal_11 = i0.ɵnov(_v, 51).ngClassUntouched;
        var currVal_12 = i0.ɵnov(_v, 51).ngClassTouched;
        var currVal_13 = i0.ɵnov(_v, 51).ngClassPristine;
        var currVal_14 = i0.ɵnov(_v, 51).ngClassDirty;
        var currVal_15 = i0.ɵnov(_v, 51).ngClassValid;
        var currVal_16 = i0.ɵnov(_v, 51).ngClassInvalid;
        var currVal_17 = i0.ɵnov(_v, 51).ngClassPending;
        _ck(_v, 46, 0, currVal_11, currVal_12, currVal_13, currVal_14, currVal_15, currVal_16, currVal_17);
        var currVal_20 = i0.ɵnov(_v, 76).ngClassUntouched;
        var currVal_21 = i0.ɵnov(_v, 76).ngClassTouched;
        var currVal_22 = i0.ɵnov(_v, 76).ngClassPristine;
        var currVal_23 = i0.ɵnov(_v, 76).ngClassDirty;
        var currVal_24 = i0.ɵnov(_v, 76).ngClassValid;
        var currVal_25 = i0.ɵnov(_v, 76).ngClassInvalid;
        var currVal_26 = i0.ɵnov(_v, 76).ngClassPending;
        _ck(_v, 70, 0, currVal_20, currVal_21, currVal_22, currVal_23, currVal_24, currVal_25, currVal_26);
        var currVal_29 = i0.ɵnov(_v, 104).ngClassUntouched;
        var currVal_30 = i0.ɵnov(_v, 104).ngClassTouched;
        var currVal_31 = i0.ɵnov(_v, 104).ngClassPristine;
        var currVal_32 = i0.ɵnov(_v, 104).ngClassDirty;
        var currVal_33 = i0.ɵnov(_v, 104).ngClassValid;
        var currVal_34 = i0.ɵnov(_v, 104).ngClassInvalid;
        var currVal_35 = i0.ɵnov(_v, 104).ngClassPending;
        _ck(_v, 99, 0, currVal_29, currVal_30, currVal_31, currVal_32, currVal_33, currVal_34, currVal_35);
        var currVal_39 = i0.ɵnov(_v, 123).ngClassUntouched;
        var currVal_40 = i0.ɵnov(_v, 123).ngClassTouched;
        var currVal_41 = i0.ɵnov(_v, 123).ngClassPristine;
        var currVal_42 = i0.ɵnov(_v, 123).ngClassDirty;
        var currVal_43 = i0.ɵnov(_v, 123).ngClassValid;
        var currVal_44 = i0.ɵnov(_v, 123).ngClassInvalid;
        var currVal_45 = i0.ɵnov(_v, 123).ngClassPending;
        _ck(_v, 118, 0, currVal_39, currVal_40, currVal_41, currVal_42, currVal_43, currVal_44, currVal_45);
    });
}
function View_RepreCausaPopupComponent_5(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'col-sm-8  isa_error msg-error']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-times-circle']], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' ', '\n                    '])), (_l()(), i0.ɵted(null, ['\n                ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.ErrorMsg;
        _ck(_v, 5, 0, currVal_0);
    });
}
function View_RepreCausaPopupComponent_6(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 6, 'div', [['class',
                'row']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 3, 'div', [['class', 'col-sm-8  isa_success']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['class', 'fa fa-check']], null, null, null, null, null)), (_l()(), i0.ɵted(null, [' ', '\n                    '])), (_l()(), i0.ɵted(null, ['\n                ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.SuccessMsg;
        _ck(_v, 5, 0, currVal_0);
    });
}
export function View_RepreCausaPopupComponent_0(_l) {
    return i0.ɵvid(0, [i0.ɵqud(402653184, 1, { msgPopup: 0 }), (_l()(), i0.ɵeld(0, null, null, 57, 'div', [['class', 'modal-dialog modal-lg'], ['role', 'document']], null, null, null, null, null)), (_l()(),
            i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 51, 'div', [['class', 'modal-content m-scroll']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n\n        '])),
        (_l()(), i0.ɵeld(0, null, null, 48, 'div', [['class', 'modal-header']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 18, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_RepreCausaPopupComponent_1)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵeld(0, null, null, 12, 'div', [['class', 'col-xs-2 col-sm-4']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 9, 'ul', [['class', 'actions pull-right']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 6, 'li', [['class', 'dropdown']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵeld(0, null, null, 3, 'a', [['aria-label', 'Close'],
            ['data-dismiss', 'modal']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.finalize() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['\n                                '])),
        (_l()(), i0.ɵeld(0, null, null, 0, 'i', [['aria-hidden', 'true'],
            ['class', 'fa fa-times']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                            '])),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 25, 'div', [['class', 'panel-body height-panel']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_RepreCausaPopupComponent_2)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_RepreCausaPopupComponent_5)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵand(16777216, null, null, 1, null, View_RepreCausaPopupComponent_6)),
        i0.ɵdid(16384, null, 0, i2.NgIf, [i0.ViewContainerRef, i0.TemplateRef], { ngIf: [0,
                'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                '])),
        (_l()(), i0.ɵeld(0, null, null, 13, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-sm-3 col-sm-offset-3']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-primary btn-verMas btn-buscar'], ['id', '_printButton']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.onClickSave() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['Aceptar'])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'col-sm-3']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-default btn-buscar'],
            ['data-dismiss', 'modal'], ['id', '_cancelButton']], null, [[null,
                'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.finalize() !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['Cancelar'])),
        (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n\n    '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 1, 'app-message', [], null, null, null, i4.View_Message_0, i4.RenderType_Message)), i0.ɵdid(49152, [[1, 4]], 0, i5.Message, [], { config: [0, 'config'] }, null),
        (_l()(), i0.ɵted(null, ['\n'])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.visible;
        _ck(_v, 10, 0, currVal_0);
        var currVal_1 = _co.visible;
        _ck(_v, 30, 0, currVal_1);
        var currVal_2 = _co.ErrorMessageIsVisible;
        _ck(_v, 33, 0, currVal_2);
        var currVal_3 = _co.SuccessMessageIsVisible;
        _ck(_v, 36, 0, currVal_3);
        var currVal_4 = _co.mensajeConfigSource;
        _ck(_v, 57, 0, currVal_4);
    }, null);
}
export function View_RepreCausaPopupComponent_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'repre-causa-popup', [], null, null, null, View_RepreCausaPopupComponent_0, RenderType_RepreCausaPopupComponent)), i0.ɵdid(114688, null, 0, i3.RepreCausaPopupComponent, [i6.UsuarioService, i1.FormBuilder, i7.ExpedienteService, i8.CommonService], null, null)], function (_ck, _v) {
        _ck(_v, 1, 0);
    }, null);
}
export var RepreCausaPopupComponentNgFactory = i0.ɵccf('repre-causa-popup', i3.RepreCausaPopupComponent, View_RepreCausaPopupComponent_Host_0, { tviListRepre: 'tviListRepre',
    tdocList: 'tdocList' }, { onClose: 'onClose', onComplete: 'onComplete' }, []);
//# sourceMappingURL=repre-causa-popup.component.ngfactory.js.map